{
    "Profile_SecureMyOffer_SellerAgreement.header": "FR: Seller agreement",
    "Profile_SecureMyOffer_SellerAgreement.agreed": "FR: The seller agreed to the application",
    "Profile_SecureMyOffer_SellerAgreement.agreedOn": "FR: Agreed on",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail": "FR: Agree email sent",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmailSentOn": "FR: Sent on",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail.confirmAndPay": "FR: Confirm and pay",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail.paidSeparately": "FR: Agree, paid separately",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail.alreadyPaid": "FR: Agree, already paid",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail.unknown": "{code}",
    "Profile_SecureMyOffer_SellerAgreement.agreeEmail.none": "FR: None yet"
}
